import React from 'react';
import { useSelector } from 'react-redux';
import { ExistingRealties } from './existingRealties';
import { OwnersByAge } from './ownersByAge';
import { OwnersByConsumptionPattern } from './ownersByConsumptionPattern';
import { OwnersByMaritalStatus } from './ownersByMaritalStatus';
import { OwnersByMonthlyIncome } from './ownersByMonthlyIncome';
import { OwnersBySchooling } from './ownersBySchooling';
import { PricePerSqMtMedian } from './pricePerSqMtMedian';
import { TransactionedOverExistingRealties } from './transactionedOverExistingRealties';

const TransactionsCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);
  return (
    <div className="realty-transactions-charts">
      <div
        className={`two-charts-container ${
          isGridView ? 'grid-layout' : 'list-layout'
        } `}
      >
        <ExistingRealties />
        <TransactionedOverExistingRealties />
      </div>
      <div
        className={`two-charts-container ${
          isGridView ? 'grid-layout' : 'list-layout'
        } `}
      >
        <PricePerSqMtMedian />
        {/* <OwnersByMonthlyIncome /> */}
      </div>
      {/* <div className="one-chart-container">
        <OwnersByAge />
      </div>
      <div
        className={`two-charts-container ${
          isGridView ? 'grid-layout' : 'list-layout'
        } `}
      >
        <OwnersBySchooling />
        <OwnersByMaritalStatus />
      </div>
      <div
        className={`two-charts-container ${
          isGridView ? 'grid-layout' : 'list-layout'
        } `}
      >
        <OwnersByConsumptionPattern />
      </div> */}
    </div>
  );
};

export default TransactionsCharts;
